import EditOrder from './EditOrder'

export default EditOrder



// WEBPACK FOOTER //
// ./src/components/Orders/Edit/index.js